<!-- Modals -->
<app-deprecated-confirmation-dialog
    #confirmDeleteCustomReportDialog
    [label]="'company.assets.delete' | translate"
    [header]="getAssetDeleteDialogHeader()"
    [description]="'company.assets.deleteConfirmation' | translate"
    [negative]="true"
></app-deprecated-confirmation-dialog>

<app-deprecated-modal-form
    #assignAssetModal
    [form]="assignAssetForm"
    [label]="'company.assets.save' | translate"
    (save)="onAssignAsset(asset.assignment)"
    (cancel)="onCancel()"
    headerText="{{ 'company.assets.assignAsset' | translate }}"
>
    <app-assign-asset #assignAssetForm [assetAssignment]="asset.assignment"></app-assign-asset>
</app-deprecated-modal-form>

<app-deprecated-modal-form
    #reassignAssetModal
    [form]="reassignAssetForm"
    [label]="'company.assets.save' | translate"
    (save)="onAssignAsset(assetReassignment)"
    (cancel)="onCancel()"
    headerText="{{ 'company.assets.reassignAsset' | translate }}"
>
    <app-reassign-asset
        #reassignAssetForm
        [assetAssignment]="asset.assignment"
        [assignee]="asset.assignment?.employee"
        [assetReassignment]="assetReassignment"
    ></app-reassign-asset>
</app-deprecated-modal-form>

<!-- Body -->
<div class="ui basic segment asset-show" [class.loading]="isLoading">
    <!-- Header -->
    <app-header [title]="title" [back]="true" backRoute="/company/assets">
        <div class="buttons">
            <ui-button type="primary" class="assign-button" (click)="showAssignAssetModal()">
                {{ (!hasAssignment() ? 'company.assets.assignAsset' : 'company.assets.reassignAsset') | translate }}
            </ui-button>

            <!-- Meatball menu -->
            <button class="material-meatball-menu-button meatball-icon-border" [matMenuTriggerFor]="menu">
                <mat-icon svgIcon="meatballHorizontal"></mat-icon>
            </button>
            <mat-menu #menu="matMenu" xPosition="before">
                <button mat-menu-item (click)="onEdit()">{{ 'company.assets.editAssetDetails' | translate }}</button>
                <button mat-menu-item (click)="onDelete()">{{ 'company.assets.delete' | translate }}</button>
            </mat-menu>
        </div>
    </app-header>

    <!-- Asset Details Card-->
    <div class="ui segment">
        <app-segment-header title="{{ 'company.assets.assetDetails' | translate }}"></app-segment-header>

        <!-- Category -->
        <div class="entity app-grid">
            <label class="columns-3 small-columns-12">{{ 'company.assets.categoryLabel' | translate }}</label>
            <span class="columns-9 small-columns-12" *ngIf="asset.category; else hasNoCategory">
                {{ asset.category.name }}
            </span>
            <ng-template #hasNoCategory>
                <span class="columns-9 small-columns-12">{{ 'company.assets.noCategory' | translate }}</span>
            </ng-template>
        </div>

        <!-- Serial Number -->
        <div class="entity app-grid">
            <label class="columns-3 small-columns-12">{{ 'company.assets.serialNumberLabel' | translate }}</label>
            <span class="columns-9 small-columns-12" *ngIf="asset.serialNumber; else hasNoSerialNumber">
                {{ asset.serialNumber }}
            </span>
            <ng-template #hasNoSerialNumber>
                <span class="columns-9 small-columns-12">{{ 'company.assets.noSerialNumber' | translate }}</span>
            </ng-template>
        </div>

        <!-- Notes -->
        <div class="entity app-grid">
            <label class="columns-3 small-columns-12">{{ 'company.assets.notesLabel' | translate }}</label>
            <span class="columns-9 small-columns-12" *ngIf="asset.notes; else hasNoNotes"> {{ asset.notes }} </span>
            <ng-template #hasNoNotes>
                <span class="columns-9 small-columns-12">{{ 'company.assets.noNotes' | translate }}</span>
            </ng-template>
        </div>

        <!-- Cost -->
        <div class="entity app-grid">
            <label class="columns-3 small-columns-12">{{ 'company.assets.costLabel' | translate }}</label>
            <span class="columns-9 small-columns-12" *ngIf="asset.cost; else hasNoCost"> {{ asset.cost }} </span>
            <ng-template #hasNoCost>
                <span class="columns-9 small-columns-12">{{ 'company.assets.noCost' | translate }}</span>
            </ng-template>
        </div>
    </div>

    <!-- Assignee History Table -->
    <div class="ui segment">
        <app-table
            [table]="table"
            [showSearch]="false"
            [useStickyHeader]="false"
            [title]="'company.assets.assignmentHistory' | translate"
            [embedded]="true"
            [isSmall]="true"
        >
            <app-empty-state [label]="'company.assets.noAssignmentHistoryFound' | translate"></app-empty-state>
        </app-table>
    </div>
</div>
